import { Injectable } from '@angular/core';
import { Features } from '@app/enums';
import { FeatureService } from '@app/startup/feature.service';
import Hotjar from '@hotjar/browser';
import { environment } from 'src/environments/environment';

const HOTJAR_VERSION = 6;

@Injectable({
  providedIn: 'root',
})
export class HotjarService {
  private initialized = false;

  public constructor(private feature: FeatureService) {}

  public init() {
    if (this.initialized || !environment.hotjarSiteId || !this.feature.isFeatureActivated(Features.TMP_HOTJAR)) {
      return;
    }
    this.initialized = Hotjar.init(environment.hotjarSiteId, HOTJAR_VERSION);
  }

  public trackEvent(eventName: string) {
    if (this.initialized) {
      Hotjar.event(eventName);
    }
  }
}
